import React from 'react';
import './style.scss';
import { Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cards from '../../../../components/molecules/cards';
import ContentContainer from './ContentContainer';
import { CoffeeInvoice } from './hooks';
import Form from '../../../../components/molecules/forms';
import { successUpdateMsg } from '../../../../components/atoms/const';
import { DollarSign } from '../../../../components/atoms/icons';
import Modal from '../../../../components/organisms/modals';

interface Props {
    onNavigate: () => void;
    onViewDetail: (invoiceId: number) => void; // ← add this line
    pendingList: CoffeeInvoice[];
    isLoading: boolean;
    formik: any;
    resultUpdate: any;
    afterUpdate: () => void;
    loadingUpdate: boolean;
    paymentData: {paid: number, bill: number}
}

function RenderPendingCoffeeInvoices(props: Props) {
  const {
    onNavigate, onViewDetail, pendingList, isLoading, formik, loadingUpdate,
    resultUpdate, afterUpdate, paymentData,
  } = props;

  const renderModalBody = (): string | React.ReactElement => {
    if (!resultUpdate) {
      return (
        <div>
          <Form.DefaultWithIcon
            id="paidAmount"
            label="Enter Amount"
            placeholder="Amount"
            value={formik.values.paidAmount}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.paidAmount && formik.touched.paidAmount}
            errorMsg={formik.errors.paidAmount}
            onBlur={formik.handleBlur}
            className="mb-4"
            disabled={loadingUpdate}
            leftIcon={<DollarSign width={23} />}
            type="number"
          />
        </div>
      );
    }
    return successUpdateMsg.SUCCESS_PAID_CLIENT_INVOICE_MSG;
  };

  const renderContentContainer = (content: React.ReactElement) => (
    <div>
      <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
      <ContentContainer
        buttonLabel="View Paid Invoices"
        onNavigate={onNavigate}
        buttonWidth={170}
        title="Pending Coffee Invoices"
      >
        {content}
      </ContentContainer>
    </div>
  );

  if (isLoading) {
    return (
      renderContentContainer(<Spinner animation="border" />)
    );
  }
  if (paymentData.paid > 0 || paymentData.bill > 0) {
    return (
      renderContentContainer(
        pendingList && pendingList.length ? (
          <div className="row">
            {pendingList.map((invoice) => (
              <div key={invoice.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2">
                <Cards.Pending
                  badgeCard={(
                    <Cards.Badge
                      id={invoice.id.toString()}
                      label="-"
                      iconType="snack"
                      isCancel={false}
                    />
                  )}
                  title="Coffee Invoice"
                  price={(invoice.paidAmount ? (invoice.billAmount - invoice.paidAmount) : invoice.billAmount) ?? 0}
                  date={new Date(invoice.dropDate)}
                  id={invoice.id.toString()}
                  onViewButton={(
                    <button
                      type="button"
                      className="btn btn-link padding-0 fz-14 align-baseline"
                      onClick={() => onViewDetail(invoice.id)}
                    >
                      View Details
                    </button>
                  )}
                  markAsPaidButton={(
                    <Modal.Default
                      cancelLabel="Cancel"
                      submitLabel="Mark as Paid"
                      title="Mark as Paid"
                      body={renderModalBody()}
                      isLoading={loadingUpdate}
                      result={resultUpdate}
                      onAfterResult={afterUpdate}
                      onSubmit={formik.handleSubmit}
                      onInit={() => {
                        formik.setFieldValue('id', invoice.id);
                        formik.setFieldValue('paidAmount', 0);
                      }}
                    >
                      <div className="fz-14 link-primary text-decoration-underline">Mark as Paid</div>
                    </Modal.Default>
                    )}
                />
              </div>
            ))}
          </div>
        ) : (
          <div>No Pending Invoice</div>
        ),
      )
    );
  }
  return null;
}

export default RenderPendingCoffeeInvoices;
